import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom'
import View from './view';
import AdminOrderCreate from './addorder';

export default class Order extends Component {
    render() {
        const { match } = this.props;
        return (
            <div id="layoutSidenav_content">
                <main>
                    <Switch>
                        <Route path={[`${match.path}/view`]} component={View} />
                        <Route path={[`${match.path}/add-order`]} component={AdminOrderCreate} />
                    </Switch>
                </main>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/admin/view/order/index.js